import {
  CREATE_APP_VERSION_REQUEST,
  CREATE_APP_VERSION_SUCCESS,
  CREATE_APP_VERSION_FAILURE,
  FETCH_APP_VERSIONS_REQUEST,
  FETCH_APP_VERSIONS_SUCCESS,
  FETCH_APP_VERSIONS_FAILURE,
  UPDATE_APP_VERSION_REQUEST,
  UPDATE_APP_VERSION_SUCCESS,
  UPDATE_APP_VERSION_FAILURE,
} from "./types";

import {
  createAppVersion,
  fetchAppVersions,
  updateAppVersion,
} from "../../services/appVersionService";

// Create action creators
export const createAppVersionRequest = () => ({
  type: CREATE_APP_VERSION_REQUEST,
});

export const createAppVersionSuccess = (appVersionData) => ({
  type: CREATE_APP_VERSION_SUCCESS,
  payload: appVersionData,
});

export const createAppVersionFailure = (error) => ({
  type: CREATE_APP_VERSION_FAILURE,
  payload: error,
});

// Fetch action creators
export const fetchAppVersionsRequest = () => ({
  type: FETCH_APP_VERSIONS_REQUEST,
});

export const fetchAppVersionsSuccess = (appVersionsData) => ({
  type: FETCH_APP_VERSIONS_SUCCESS,
  payload: appVersionsData,
});

export const fetchAppVersionsFailure = (error) => ({
  type: FETCH_APP_VERSIONS_FAILURE,
  payload: error,
});

// Update action creators
export const updateAppVersionRequest = () => ({
  type: UPDATE_APP_VERSION_REQUEST,
});

export const updateAppVersionSuccess = (updatedAppVersion) => ({
  type: UPDATE_APP_VERSION_SUCCESS,
  payload: updatedAppVersion,
});

export const updateAppVersionFailure = (error) => ({
  type: UPDATE_APP_VERSION_FAILURE,
  payload: error,
});

// Thunk to create app version
export const createAppVersionAction = (appVersionData) => async (dispatch) => {
  dispatch(createAppVersionRequest());

  try {
    const response = await createAppVersion(appVersionData);

    if (response.success) {
      dispatch(createAppVersionSuccess(response.data.data));
      return { success: true, data: response.data };
    } else {
      dispatch(createAppVersionFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to create app version";
    dispatch(createAppVersionFailure(errMsg));
    return { success: false, error: errMsg };
  }
};

// Thunk to fetch app versions
export const fetchAppVersionsAction = (platform = "android") => async (dispatch) => {
  dispatch(fetchAppVersionsRequest());

  try {
    const response = await fetchAppVersions(platform);

    if (response.success) {
      dispatch(fetchAppVersionsSuccess(response.data.data));
      return { success: true, data: response.data.data };
    } else {
      dispatch(fetchAppVersionsFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to fetch app versions";
    dispatch(fetchAppVersionsFailure(errMsg));
    return { success: false, error: errMsg };
  }
};

export const fetchIOSAppVersionsAction = () => async (dispatch) => {
  dispatch(fetchAppVersionsRequest());

  try {
    const response = await fetchAppVersions("ios");

    if (response.success) {
      dispatch(fetchAppVersionsSuccess(response.data.data));
      return { success: true, data: response.data.data };
    } else {
      dispatch(fetchAppVersionsFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to fetch iOS app versions";
    dispatch(fetchAppVersionsFailure(errMsg));
    return { success: false, error: errMsg };
  }
};

// Thunk to update app version
export const updateAppVersionAction = (versionId, updateData) => async (dispatch) => {
  dispatch(updateAppVersionRequest());

  try {
    const response = await updateAppVersion(versionId, updateData);

    if (response.success) {
      dispatch(updateAppVersionSuccess(response.data.data));
      return { success: true, data: response.data };
    } else {
      dispatch(updateAppVersionFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to update app version";
    dispatch(updateAppVersionFailure(errMsg));
    return { success: false, error: errMsg };
  }
};